import React from 'react'
import {
  Edit,
  TextInput,
  useTranslate,
  BooleanInput,
  TabbedForm,
  FormTab,
  useNotify,
  useRedirect,
  required,
  TabbedFormTabs,
} from 'react-admin'
import { FieldArray } from './logic/ArrayInput'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { MirrorTab } from './logic/MirrorTab'

export const ClientEdit = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.updated_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.client') }
    })
    redirect('/client')
  }

  const onError = () => {
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.client') }
    })
  }

  return (
    <Edit {...props} mutationMode='pessimistic' mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.update_client')}>
        <TabbedForm
          toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['short_name']} genderElement='masculine' />}
          tabs={<TabbedFormTabs variant="scrollable" scrollButtons="auto" />}
        >
          <FormTab label={translate('ra.entity.client')}>
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.id')}>
                <TextInput disabled source='id' label='' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.short_name')} required>
                <TextInput source='short_name' validate={[required()]} label='' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.long_name')}>
                <TextInput source='long_name' label='' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.is_active')}>
                <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
              </EditInputsWrap>
            </Grid>
          </FormTab>
          <FormTab label={translate('ra.entity.config_application')}>
            <FieldArray />
          </FormTab>
          <FormTab label={'Mirror'}>
            <MirrorTab />
          </FormTab>
        </TabbedForm>
      </CardCommon>
    </Edit>
  )
}
